import * as angular from 'angular';
import toastr from 'toastr';

angular
  .module('screeningcanvas')
  .directive('transactionTagSelector', ['newApiClient', function (newApiClient) {
    return {
      restrict: 'A',
      scope: {
        optional: '=?',
        optionalText: "@",
      },
      template: '<option ng-if="optional" value="">{{ (!!optionalText) ? optionalText : "Nessuna" }}</option><option value="{{ item.id }}" ng-repeat="item in items">{{ item.name }}</option>',
      replace: false,
      controller: ['$scope', function ($scope) {
        $scope.items = [];

        $scope.fetch = function () {
          newApiClient.call(`
            query {
              transactionTags {
                allTransactionTags {
                  id
                  name
                }
              }
            }`,
            {},
          ).then(function (data) {
            $scope.items = data.transactionTags.allTransactionTags;
          }, function () {
            toastr.error("Impossibile caricare le categorie entrate uscite");
          });
        };
        $scope.fetch();
      }],
    };
  }]);
